/* eslint-disable comma-dangle */
import { keyframes } from 'styled-components';


const host = window?.location?.host;

export const ENV_BASED_CONFIGS = {
  'price.daykarkal.com': {
    url: 'https://api.daykarkal.com',
    companyName: 'DayKarkal',
    subCompanyId: '558375c5-db94-4ef2-9fcd-7df4c9788483',
  },
  'staging-price.daykarkal.com': {
    url: 'https://staging-api.daykarkal.com',
    companyName: 'DayKarkal',
    subCompanyId: '558375c5-db94-4ef2-9fcd-7df4c9788483',

  },
  'price.milways.gold': {
    url: 'https://apiv2.milways.gold',
    companyName: 'Milways',
    subCompanyId: '88cfea77-fc3d-487c-9c7b-7aba54d93cff',

  },
  'localhost:3001': {
    url: 'http://localhost:33581',
    companyName: 'Milways',
    subCompanyId: '88cfea77-fc3d-487c-9c7b-7aba54d93cff',
  },
  // 本機開發：指住自己部 ERP backend。3001 係指住 production 嘅，兩個 port 分開行，
  // 唔使為咗試嘢改嚟改去。
  'localhost:3002': {
    url: 'http://localhost:33581',
    companyName: 'Milways',
    subCompanyId: '88cfea77-fc3d-487c-9c7b-7aba54d93cff',
  },
  default: {
    // url: 'https://api.daykarkal.com',
    url: 'https://api.daykarkal.com',
    companyName: 'DayKarkal',
    subCompanyId: '88cfea77-fc3d-487c-9c7b-7aba54d93cff',
  },
};

// 落 `default` 唔係 `development` —— 個 map 根本冇 `development` 呢個 key，所以任何未列出嘅
// host（例如行錯 port）會攞到 undefined，下面 `.url` 即刻 throw，成個 app 白畫面。
const HOST_CONFIG = ENV_BASED_CONFIGS[host] || ENV_BASED_CONFIGS.default;

/**
 * `.env.local` 覆寫（CRA 只讀 `REACT_APP_` 開頭嘅 key，改完要重開 dev server）：
 *
 *   REACT_APP_API_URL=http://localhost:33581
 *   REACT_APP_SUB_COMPANY_ID=<sub company uuid>
 *
 * 有咗呢個就唔使再為咗試本機而改上面個 host map（`dev` 行邊個 port 都得）。
 */
export const ENV_BASED_CONFIG = {
  ...HOST_CONFIG,
  ...(process.env.REACT_APP_API_URL ? { url: process.env.REACT_APP_API_URL } : {}),
  ...(process.env.REACT_APP_SUB_COMPANY_ID
    ? { subCompanyId: process.env.REACT_APP_SUB_COMPANY_ID }
    : {}),
};

export const BASE_URL = ENV_BASED_CONFIG.url;
export const BASE_URL_NAME = ENV_BASED_CONFIG.companyName;
/**
 * WebSocket URL：`https://` → `wss://`、`http://` → `ws://`。
 * 舊寫法係 `wss` + `BASE_URL.replaceAll('https', '')`，靠個字串一定以 `https` 開頭 ——
 * 本機 backend 係 `http://`，冇 `https` 可 replace，砌出嚟會變 `wsshttp://localhost:33581`。
 */
export const WS_BASE_URL = String(BASE_URL || '').replace(/^http/, 'ws');

export const WIDTH_SHORTEN_THRESHOLD = 1024;
export const WIDTH_THRESHOLD = 768;
export const MAX_DESKTOP_WIDTH = 1100;

// NOTE: In future use colors in theme.js
export const COLORS = {
  white: '#FFFFFF',
  black: '#000000',
  grey1: '#333842',
  grey2: '#282C34',
  grey3: '#1A1E1F',
  dark: '#0E0C34',
  purple1: '#D585FF',
  purple2: '#BF77E6',
  purple3: '#9F63BF',
  skyblue: '#64CCF7',
  blue1: '#a4d9f6',
  blue2: '#80c9f2',
  blue3: '#69b7e3',
  green1: '#8BFCE5',
  green2: '#7DE3CF',
  green3: '#68BDAC',
  pink: '#FCC5B1',
  orange: '#FCD4A4',
  alert: '#DE3146',
  darkBlack: '#050505',
  primary: '#a48a7b',
  main: 'white',
  highlight: '#fdb720',
  shadedHighlight: '#91651d',
  highlight2: 'rgb(239, 182, 21)',
  secondary: '#b5b8fc',
};

export const getLtMediaQuery = size => `@media only screen and (max-width: ${size}px)`;

export const XS_WIDTH = 600;
export const SM_WIDTH = 960;
export const MD_WIDTH = 1280;
export const LG_WIDTH = 1920;

export const MediaQueryMobileOnly = getLtMediaQuery(WIDTH_THRESHOLD);
export const MediaQueryShortenOnly = getLtMediaQuery(WIDTH_SHORTEN_THRESHOLD + 1);

export const MediaQueryXSOnly = getLtMediaQuery(XS_WIDTH);
export const MediaQuerySMOnly = getLtMediaQuery(SM_WIDTH);
export const MediaQueryMDOnly = getLtMediaQuery(MD_WIDTH);
export const MediaQueryLGOnly = getLtMediaQuery(LG_WIDTH);

export const CONTAINER_MAX_WIDTH = 1200;

export const ROTATE_KEYFRAMES = keyframes`
0% { transform: rotate(0deg); }
50% { transform: rotate(180deg);  }
100% { transform: rotate(360deg);  }
`;

// 胸針 男仕珠寶

// export const inventoryDesc = {
//   oceanic: '',
//   brooch: '配戴高雅的胸針能展示高貴的生活品味',
//   'men-jewellery': 'DAY KARKAL為時尚男士精選的極致作品系列。精緻的珠寶、奢華的配飾成就當下男士的獨特風格。',
// };


export const DIAMOND_ATTRIBUTES_NAMES = [
  'SKU',
  'SHAPE',
  'LAB',
  'REPORTNO',
  'CARAT',
  'COLOR',
  'CLARITY',
  'CUT',
  'POLISH',
  'SYMMETRY',
  'FLUORESCENCE',
  'THUMBNAIL',
  'IMAGES',
  'WEB',
];

export const LAB_GROWN_CUT = {
  GD: {
    label: 'Good',
    short: 'GD',
    lv: 0,
  },
  VG: {
    label: 'Very good',
    short: 'VG',
    lv: 1,
  },
  EX: {
    label: 'Excellent',
    short: 'EX',
    lv: 2,
  },
  ID: {
    label: 'Ideal',
    short: 'ID',
    lv: 3,
  },
};

export const DIAMOND_LEVEL = {
  GD: {
    label: 'Good',
    short: 'GD',
    lv: 0,
  },
  VG: {
    label: 'Very good',
    short: 'VG',
    lv: 1,
  },
  EX: {
    label: 'Excellent',
    short: 'EX',
    lv: 2,
  },
  // F: {
  //   label: 'Fair',
  //   short: 'F',
  //   lv: 3,
  // },
  // P: {
  //   label: 'Poor',
  //   short: 'P',
  //   lv: 4,
  // },
};

export const DIAMOND_SHAPE = {
  ROUND: {
    image: '/images/diamond/ROUND.png',
    isVideoImage: '/images/diamond/round-video.svg',
    is360Image: '/images/diamond/round-360.svg',
    isBothImage: '/images/diamond/round-both.svg',
    hoverText: '圓形',
  },
  OVAL: {
    image: '/images/diamond/OVAL.png',
    isVideoImage: '/images/diamond/oval-video.svg',
    is360Image: '/images/diamond/oval-360.svg',
    isBothImage: '/images/diamond/oval-both.svg',
    hoverText: '橢圓形',
  },
  MARQUISE: {
    image: '/images/diamond/MARQUISE.png',
    isVideoImage: '/images/diamond/marquise-video.svg',
    is360Image: '/images/diamond/marquise-360.svg',
    isBothImage: '/images/diamond/marquise-both.svg',
    hoverText: '橄欖形',
  },
  PEAR: {
    image: '/images/diamond/PEAR.png',
    isVideoImage: '/images/diamond/pear-video.svg',
    is360Image: '/images/diamond/pear-360.svg',
    isBothImage: '/images/diamond/pear-both.svg',
    hoverText: '梨形',
  },
  HEART: {
    image: '/images/diamond/HEART.png',
    isVideoImage: '/images/diamond/heart-video.svg',
    is360Image: '/images/diamond/heart-360.svg',
    isBothImage: '/images/diamond/heart-both.svg',
    hoverText: '心形',
  },
  CUSHION: {
    image: '/images/diamond/CUSHION.png',
    isVideoImage: '/images/diamond/cushion-video.svg',
    is360Image: '/images/diamond/cushion-360.svg',
    isBothImage: '/images/diamond/cushion-both.svg',
    hoverText: '枕形',
  },
  ASSCHER: {
    image: '/images/diamond/ASSCHER.png',
    isVideoImage: '/images/diamond/asscher-video.svg',
    is360Image: '/images/diamond/asscher-360.svg',
    isBothImage: '/images/diamond/asscher-both.svg',
    hoverText: '上丁方形',
  },
  PRINCESS: {
    image: '/images/diamond/PRINCESS.png',
    isVideoImage: '/images/diamond/princess-video.svg',
    is360Image: '/images/diamond/princess-360.svg',
    isBothImage: '/images/diamond/princess-both.svg',
    hoverText: '公主方形',
  },
  EMERALD: {
    image: '/images/diamond/EMERALD.png',
    isVideoImage: '/images/diamond/emerald-video.svg',
    is360Image: '/images/diamond/emerald-360.svg',
    isBothImage: '/images/diamond/emerald-both.svg',
    hoverText: '祖母綠形',
  },
  OTHER: {
    image: '/images/diamond/OTHER.png',
    isVideoImage: '/images/diamond/other-video.svg',
    is360Image: '/images/diamond/other-360.svg',
    isBothImage: '/images/diamond/other-both.svg',
    hoverText: '其它',
  },
};

export const DIAMOND_FLUORESCENCE = {
  S: {
    label: 'Strong',
    lv: 0,
    short: 'S',
  },
  M: {
    label: 'Medium',
    lv: 1,
    short: 'M',
  },
  F: {
    label: 'Faint',
    lv: 2,
    short: 'F',
  },
  N: {
    label: 'None',
    lv: 3,
    short: 'N',
  },
};

export const DIAMOND_CLARITY = {
  // I3: {
  //   label: 'I3',
  //   lv: 0,
  // },
  // I2: {
  //   label: 'I2',
  //   lv: 1,
  // },
  // I1: {
  //   label: 'I1',
  //   lv: 2,
  // },
  SI2: {
    label: 'SI2',
    lv: 0,
  },
  SI1: {
    label: 'SI1',
    lv: 1,
  },
  VS2: {
    label: 'VS2',
    lv: 2,
  },
  VS1: {
    label: 'VS1',
    lv: 3,
  },
  VVS2: {
    label: 'VVS2',
    lv: 4,
  },
  VVS1: {
    label: 'VVS1',
    lv: 5,
  },
  IF: {
    label: 'IF',
    lv: 6,
  },
  FL: {
    label: 'FL',
    lv: 7,
  },
};

export const FANCY_DIAMOND_COLORS = {
  RED: {
    hoverText: '紅色',
    value: 'red',
    image: '/images/diamond/fancy-diamond-color-Red.svg',
  },
  ORANGE: {
    hoverText: '橙色',
    value: 'orange',
    image: '/images/diamond/fancy-diamond-color-Orange.svg',
  },
  PINK: {
    hoverText: '粉紅',
    value: 'pink',
    image: '/images/diamond/fancy-diamond-color-Pink.svg',
  },
  YELLOW: {
    hoverText: '黃色',
    value: 'yellow',
    image: '/images/diamond/fancy-diamond-color-Yellow.svg',
  },
  GREEN: {
    hoverText: '綠色',
    value: 'green',
    image: '/images/diamond/fancy-diamond-color-Green.svg',
  },
  BLUE: {
    hoverText: '藍色',
    value: 'blue',
    image: '/images/diamond/fancy-diamond-color-Blue.svg',
  },
  PURPLE: {
    hoverText: '紫色',
    value: 'purple',
    image: '/images/diamond/fancy-diamond-color-Purple.svg',
  },
  GREY: {
    hoverText: '灰色',
    value: 'grey',
    image: '/images/diamond/fancy-diamond-color-Grey.svg',
  },
  BROWN: {
    hoverText: '啡色',
    value: 'brown',
    image: '/images/diamond/fancy-diamond-color-Brown.svg',
  },
  BLACK: {
    hoverText: '黑色',
    value: 'black',
    image: '/images/diamond/fancy-diamond-color-Black.svg',
  },
};

export const DIAMOND_COLOR = {};

const END_COLOR_CHAR = 'M';

export const EndColorCharCode = END_COLOR_CHAR.charCodeAt(0);

let num = -1;
for (let i = 'D'.charCodeAt(0); i <= EndColorCharCode; i++) {
  const char = String.fromCharCode(i);
  DIAMOND_COLOR[char] = {
    label: i === EndColorCharCode ? `>${END_COLOR_CHAR}` : char,
    value: char,
    lv: ++num,
  };
}

export const LAB_DIAMOND_COLOR = {
  K: {
    label: 'K',
    value: 'K',
    lv: 0
  },
  J: {
    label: 'J',
    value: 'J',
    lv: 1
  },
  I: {
    label: 'I',
    value: 'I',
    lv: 2
  },
  H: {
    label: 'H',
    value: 'H',
    lv: 3
  },
  G: {
    label: 'G',
    value: 'G',
    lv: 4
  },
  F: {
    label: 'F',
    value: 'F',
    lv: 5
  },
  E: {
    label: 'E',
    value: 'E',
    lv: 6
  },
  D: {
    label: 'D',
    value: 'D',
    lv: 7
  },
};

export const GIA_CERT_TITLE = '證書編號';

export const DESCRIPTION_TITLE_COLOR = '#957370';

export const LAB_DIAMOND_CAT_ID = '491c65de-dd25-4c95-99e1-6d1198dbccec';

export const FRONT_PAGE_DATA = [
  {
    src: '/images/frontpage/v2/DKK_frontpage_icon_免手續費信用卡付款.png',
    text: '免手續費信用卡付款',
  },
  {
    src: '/images/frontpage/v2/DKK_frontpage_icon_絕不硬銷.png',
    text: '絕不硬銷',
  },
  {
    src: '/images/frontpage/v2/DKK_frontpage_icon_性價比高.png',
    text: '性價比高',
  },
  {
    src: '/images/frontpage/v2/DKK_frontpage_icon_GIA_IGI認證鑽石.png',
    text: 'GIA/IGI認證鑽石',
  },
  {
    src: '/images/frontpage/v2/DKK_frontpage_icon_永久保修.png',
    text: '永久保修',
  },
  {
    src: '/images/frontpage/v2/DKK_frontpage_icon_免費專業咨詢.png',
    text: '免費專業咨詢',
  },
];

export const FB_URL = 'https://www.facebook.com/DayKarkal/';
export const IG_URL = 'https://www.instagram.com/daykarkal/';
export const WHATSAPP_URL = 'https://bit.ly/3uoR8Jp';
export const XHS_URL = 'https://www.xiaohongshu.com/user/profile/625e6da7000000001000efa2';
export const TWITTER_URL = 'https://twitter.com/daykarkal';

export const DIAMOND_LAB_ENVIROMENT = {
  GIA: 'gia',
  IGI: 'igi',
};


export const designList = {
  name: '裝飾',
  label: 'TYPE',
  types: [{ name: '單鑽', label: '單石' }, { name: '伴鑽', label: '單邊配鑽' }, { name: '伴鑽', label: '兩邊配鑽' }, { name: '排鑽', label: '排鑽' }],
};

export const embedList = {
  name: '金屬',
  label: 'PRONG',
  types: [{ name: '三爪' }, { name: '四爪' }, { name: '六爪' }],
};

export const metalList = {
  name: '金屬',
  label: 'METAL',
  types: [{ name: '18K White Gold', label: '18K白金' }, { name: '18K黃金', label: '18K黃金' }, { name: '18K玫瑰金', label: '18K玫瑰金' }, { name: '組合18K金', label: '組合18K金' }, { name: '鉑金', label: '鉑金', }],
};

export const armList = {
  name: '設計',
  label: 'DESIGN',
  types: [{ name: '直線', label: '直線' }, { name: '曲線', label: '曲線' }, { name: '交叉', label: '交叉' }, { name: '尖形', label: '尖形' }],
};

export const styleList = {
  name: '風格',
  label: 'STYLE',
  types: [{ name: '經典', label: '簡約' }, { name: '優雅', label: '女性化' }, { name: '獨特', label: '獨特' }, { name: '顯大', label: '顯大' }],
};

export const STORE_ADDRESS = '尖沙咀漢口道15號漢口中心地下G17鋪';

export const RING_SIZE_OPTIONS = [
  {
    label: '港度 #6',
    value: '港度 #6',
  },
  {
    label: '港度 #7',
    value: '港度 #7',
  },
  {
    label: '港度 #8',
    value: '港度 #8',
  },
  {
    label: '港度 #9',
    value: '港度 #9',
  },
  {
    label: '港度 #10',
    value: '港度 #10',
  },
  {
    label: '港度 #11',
    value: '港度 #11',
  },
  {
    label: '港度 #12',
    value: '港度 #12',
  },
  {
    label: '港度 #13',
    value: '港度 #13',
  },
  {
    label: '港度 #14',
    value: '港度 #14',
  },
  {
    label: '港度 #15',
    value: '港度 #15',
  },
  {
    label: '港度 #16',
    value: '港度 #16',
  },
  {
    label: '港度 #17',
    value: '港度 #17',
  },
  {
    label: '港度 #18',
    value: '港度 #18',
  },
  {
    label: '港度 #19',
    value: '港度 #19',
  },
  {
    label: '港度 #20',
    value: '港度 #20',
  },
];

export const SERVICES_OPTIONS = [
  {
    title: '鑽石',
    image: '/images/icons/diamond-frame.png',
    link: '/diamonds',
  },
  {
    title: '求婚戒指',
    image: '/images/icons/engagement-ring-frame.png',
    link: '/engagement',
  },
  {
    title: '結婚戒指',
    image: '/images/icons/wedding-ring-frame.png',
    link: '/weddings',
  },
  {
    title: '黃金報價',
    image: '/images/icons/gold-frame.png',
    link: '/gold-price',
  },
  // {
  //   title: '黃金飾品',
  //   image: '/images/icons/gold-products-frame.png',
  //   link: '/gold-price',
  // },
  {
    title: '時尚飾品',
    image: '/images/icons/fashionable-frame.png',
    link: '/fashion-jewellery',
  },
];

export const FASHION_JEWELLERY_CATEGORY = [
  {
    image: '/images/icons/fashion-ring.png',
    title: '戒指',
    pageUrl: '/fashion/rings',
    catID: 'c180702a-a44f-466d-a02f-ecd5a4aa7c7f'
  },
  {
    image: '/images/icons/fashion-bracelet.png',
    title: '手鐲/手鏈',
    pageUrl: '/fashion/bracelets',
    catID: '4ef455d2-cb89-4323-833a-6fd95d8a0e91'
  },
  {
    image: '/images/icons/fashion-neckalace.png',
    title: '吊墜',
    pageUrl: '/fashion/pendants',
    catID: '4ef455d2-cb89-4323-833a-6fd95d8a0e91'
  },
  {
    image: '/images/icons/fashion-neckalace-1.png',
    title: '項鏈',
    pageUrl: '/fashion/necklaces',
    catID: '28cee624-622d-430d-b4a6-7b8804ac9491'
  },
  {
    image: '/images/icons/fashion-earring.png',
    title: '耳環',
    pageUrl: '/fashion/earrings',
    catID: '0344f745-5908-4847-aab4-ebb0616d9ffb'
  },
];


export const FASHION_JEWELLERY_FILTER_MAP = {
  價錢:
    [
      {
        label: '低於HK$3,000',
        min: 0,
        max: 3000,
      },
      {
        label: 'HK$3,001 - HK$5,000',
        min: 3001,
        max: 5000,
      },
      {
        label: 'HK$5,001 - HK$7,000',
        min: 5001,
        max: 7000,
      },
      {
        label: 'HK$7,001 - HK$9,000',
        min: 7001,
        max: 9000,
      },
      {
        label: 'HK$9,001 - HK$11,000',
        min: 9001,
        max: 11000,
      },
      {
        label: 'HK$11,001以上',
        min: 11000,
        max: 100000000,
      },
    ],
  排序:
    [
      {
        label: '價格由低至高',
        value: 'ASC',
      },
      {
        label: '價格由高至低',
        value: 'DESC',
      },
    ],
};
